import React, { useContext, useState, useEffect } from 'react'
import Header from '../../../Components/Header'
// teal #20c997
// dark light grey f7f9fa
import MellaModel from '../../../assets/mella-model.png'
import RightImage from '../../../assets/right-img.png'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link } from 'react-router-dom';
import { appContext } from '../../../Context/appProvider';
import Typewriter from 'typewriter-effect';
import { motion, AnimatePresence } from "framer-motion";
import { settingsContext } from '../../../Context/settingsProvider';

export default function L1() {
  const {categories} = useContext(appContext)
  const [index, setIndex] = useState(0);
  const {t, userLang} = useContext(settingsContext)
  const strings = [t('GRAPHICS_DESIGN'), t('PROGRAMMING'), t('FASHION_DESIGN'), t('VIDEO_EDITTING'), t('MANY_MORE')]

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % strings.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='w-full flex flex-col bg-main h-[300px] max-md:h-[450px] overflow-hidden pt-[60px] relative'>
        <Header noShadow withLogo />
        <div className='flex flex-1 max-md:flex-col-reverse gap-4 max-md:gap-1 items-center pl-[20%] max-md:pl-4'>
            {/* <img src={MellaModel} alt='Mella Model' className='w-[250px] object-contain max-md:hidden' /> */}
            <img src={MellaModel} alt='Mella Model' className='w-[250px] object-contain max-md:w-[200px]' />
            <div className='flex flex-col gap-3 max-md:gap-2'>
                {/* <h1 className='text-white font-bold text-5xl max-md:text-4xl'>Learn <Typewriter
                  options={{
                    strings,
                    autoStart: true,
                    loop: true,
                    delay: 20,
                    deleteSpeed: 20,
                    cursor: ''
                  }}
                /></h1> */}
                 <h1 className='text-white font-bold text-5xl max-md:text-4xl flex gap-1' style={{
                   flexDirection: userLang == 'en' ? 'column' : 'column-reverse'
                 }}>{t('LEARN')} 
                 <AnimatePresence mode="popLayout">
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: -50 }}  // Start from top
                      animate={{ opacity: 1, y: 0 }}   // Move to center
                      exit={{ opacity: 0, y: 50 }}     // Move to bottom and fade out
                      transition={{ duration: 0.2 }}
                      className=""
                    >
                      {strings[index]}
                    </motion.div>
                  </AnimatePresence>
                 </h1>
                <p className='text-white text-sm opacity-80'>{t('BANNER_TEXT')}</p>
                <Link to={categories ? '/category/' + categories?.at(0)?.name.replace(/ /g, '-') : ''} className='p-2 pl-3 pr-3 rounded-sm bg-white text-main no-underline text-md w-fit font-bold'>{t('BROWS_ALL_COURSES')}
                    <ArrowForwardIosIcon style={{fontSize: 20, marginLeft: 7}}>Filled</ArrowForwardIosIcon>
                </Link>
            </div>
            {/* <img src={RightImage} alt='Mella Model' className='w-[350px] object-contain max-md:hidden' /> */}
        </div>
    </div>
  )
}